import "core-js/modules/es.object.define-property.js";
var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/GTechIssue.ts";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { HistoryChanges as BaseHistoryChanges } from './HistoryChanges';
import { IssueStatus } from './IssueStatus';
import { IssueAnswer } from './IssueAnswer';
import { createPredicate } from './createPredicate';
import { Assignee } from './Assignee';
import { Attribute } from './Attribute';
import { ApiDomain } from './domain';
export var GTechIssue;
(function (_GTechIssue) {
  var _t$type;
  var domain = ApiDomain.domain('GTechIssue', {
    name: "domain",
    sid: "-tjivyr"
  });
  var Description = t.union([t.string, t["null"], t.undefined]);
  var Name = t.string;
  var Deadline = t.union([t.string, t["null"], t.undefined]);
  var Author = t.union([t.string, t["null"], t.undefined]);
  var AllowedActions = t.type({
    changeStatus: t.type((_t$type = {}, _defineProperty(_t$type, IssueStatus.Enum.DRAFT, t["boolean"]), _defineProperty(_t$type, IssueStatus.Enum.NOT_RELEVANT, t["boolean"]), _defineProperty(_t$type, IssueStatus.Enum.NOT_STARTED, t["boolean"]), _defineProperty(_t$type, IssueStatus.Enum.IN_PROCESS, t["boolean"]), _defineProperty(_t$type, IssueStatus.Enum.ON_REVIEW, t["boolean"]), _defineProperty(_t$type, IssueStatus.Enum.CLOSED, t["boolean"]), _t$type)),
    changeableFields: t.type({
      name: t["boolean"],
      description: t["boolean"],
      assignees: t["boolean"],
      deadline: t["boolean"],
      attributes: t["boolean"],
      author: t["boolean"]
    }),
    file: t.type({
      add: t["boolean"],
      "delete": t.array(t.number)
    })
  });
  var AbstractIssueProperties = _GTechIssue.AbstractIssueProperties = t.type({
    id: t.number,
    version: t.number,
    deleted: t["boolean"],
    readOnly: t["boolean"],
    status: IssueStatus.io,
    createdAt: t.union([t.string, t.undefined]),
    updatedAt: t.union([t.string, t.undefined]),
    assignees: t.array(Assignee),
    description: Description,
    name: Name,
    projectUrn: t.string,
    deadline: Deadline,
    attributes: t.array(Attribute),
    author: t.string
  });
  var Issue = _GTechIssue.Issue = t.intersection([AbstractIssueProperties, t.type({
    type: t.literal('Issue')
  })]);
  var IssuePopulated = _GTechIssue.IssuePopulated = t.intersection([AbstractIssueProperties, t.type({
    type: t.literal('IssuePopulated'),
    answer: t.union([t["null"], IssueAnswer.io]),
    allowedActions: AllowedActions
  })]);
  var isIssue = _GTechIssue.isIssue = createPredicate('Issue');
  var isIssuePopulated = _GTechIssue.isIssuePopulated = createPredicate('IssuePopulated');
  var Data = _GTechIssue.Data = t.type({
    list: t.array(Issue),
    total: t.number
  });
  var SortableField;
  (function (SortableField) {
    SortableField["name"] = "name";
    SortableField["description"] = "description";
    SortableField["status"] = "status";
    SortableField["deadline"] = "deadline";
    SortableField["createdAt"] = "createdAt";
    SortableField["updatedAt"] = "updatedAt";
    SortableField["id"] = "id";
    SortableField["author"] = "author";
  })(SortableField || (SortableField = {}));
  _GTechIssue.SortableField = SortableField;
  var fetchList = _GTechIssue.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: Data,
    getKey: ['limit', 'offset', 'filter', 'projectUrn', 'showNotRelevant']
  });
  var fetchXlsx = _GTechIssue.fetchXlsx = ApiCallService.create({
    name: 'fetchListXlsx',
    parentDomain: domain,
    result: t.unknown,
    getKey: function getKey() {
      return '0';
    }
  });
  var FetchAllowedFiltersResponse = _GTechIssue.FetchAllowedFiltersResponse = t.type({
    assignees: t.array(Assignee),
    attributeValueIds: t.array(t.number),
    authorIds: t.array(t.string),
    statuses: t.array(IssueStatus.io),
    createdDateRange: t.union([t.tuple([t.string, t.string]), t["null"]]),
    updatedDateRange: t.union([t.tuple([t.string, t.string]), t["null"]]),
    deadlineRange: t.union([t.tuple([t.string, t.string]), t["null"]])
  });
  var fetchAllowedFilters = _GTechIssue.fetchAllowedFilters = ApiCallService.create({
    name: 'fetchAllowedFilters',
    parentDomain: domain,
    result: FetchAllowedFiltersResponse,
    getKey: ['projectUrn', 'showNotRelevant']
  });
  var File = _GTechIssue.File = t.type({
    id: t.number,
    s3Key: t.string,
    issueId: t.number,
    issueVersion: t.number,
    name: t.string,
    uploadAt: t.string
  });
  var fetch = _GTechIssue.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['id', 'version']
  });
  var fetchMostRecent = _GTechIssue.fetchMostRecent = ApiCallService.create({
    name: 'fetchMostRecent',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['id']
  });
  var update = _GTechIssue.update = ApiCallService.create({
    name: 'update',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['id', 'version', 'description', 'name']
  });
  var create = _GTechIssue.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['description', 'name', 'projectUrn', 'status']
  });
  var startUploadFile = _GTechIssue.startUploadFile = ApiCallService.create({
    name: 'startUploadFile',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['issueId', 'issueVersion']
  });
  var addFile = _GTechIssue.addFile = ApiCallService.create({
    name: 'addFile',
    parentDomain: domain,
    result: File,
    getKey: ['issueId', 'issueVersion']
  });
  var uploadFile = _GTechIssue.uploadFile = ApiCallService.create({
    name: 'uploadFile',
    parentDomain: domain,
    result: File,
    getKey: ['issueId', 'issueVersion']
  });
  var deleteFile = _GTechIssue.deleteFile = ApiCallService.create({
    name: 'deleteFile',
    parentDomain: domain,
    result: File,
    getKey: ['fileId', 'issueId', 'issueVersion']
  });
  var downloadFile = _GTechIssue.downloadFile = ApiCallService.create({
    name: 'downloadFile',
    parentDomain: domain,
    result: t.string,
    getKey: ['fileId']
  });
  var fetchContentFiles = _GTechIssue.fetchContentFiles = ApiCallService.create({
    name: 'fetchContentFiles',
    parentDomain: domain,
    result: t.array(File),
    getKey: ['issueId', 'issueVersion']
  });
  var HistoryItemName = _GTechIssue.HistoryItemName = BaseHistoryChanges.Item(t.literal('name'), Name);
  var HistoryItemDescription = _GTechIssue.HistoryItemDescription = BaseHistoryChanges.Item(t.literal('description'), Description);
  var HistoryItemStatus = _GTechIssue.HistoryItemStatus = BaseHistoryChanges.Item(t.literal('status'), IssueStatus.io);
  var HistoryItemAuthor = _GTechIssue.HistoryItemAuthor = BaseHistoryChanges.Item(t.literal('author'), Author);
  var HistoryItemAssignee = _GTechIssue.HistoryItemAssignee = t.intersection([BaseHistoryChanges.CommonItemFields, t["interface"]({
    field: t.literal('__issueAssignee'),
    oldValue: t.array(Assignee),
    newValue: t.array(Assignee),
    deletedAssignees: t.array(Assignee)
  })], 'HistoryItemAssignee');
  var HistoryDeadlineItem = _GTechIssue.HistoryDeadlineItem = BaseHistoryChanges.Item(t.literal('deadline'), Deadline);
  var HistoryItemAttribute = _GTechIssue.HistoryItemAttribute = t.intersection([BaseHistoryChanges.CommonItemFields, t["interface"]({
    field: t.literal('__issueAttribute'),
    oldValue: t.array(Attribute),
    newValue: t.array(Attribute),
    addedAttributes: t.array(Attribute),
    deletedAttributes: t.array(Attribute)
  })], 'HistoryItemAttribute');
  var HistoryFileItem = _GTechIssue.HistoryFileItem = t.intersection([BaseHistoryChanges.CommonItemFields, t["interface"]({
    field: t.literal('_file'),
    filename: t.string
  })], 'HistoryFileItem');
  var HistoryAnswerItem = _GTechIssue.HistoryAnswerItem = t.intersection([BaseHistoryChanges.CommonItemFields, t["interface"]({
    field: t.literal('_issueAnswer'),
    status: IssueAnswer.Status,
    type: t.literal('IssueAnswer'),
    description: t.string,
    createdAt: t.string,
    authorId: t.string,
    id: t.number,
    issueVersion: t.number
  })], 'HistoryAnswerItem');
  var HistoryItem = _GTechIssue.HistoryItem = t.union([HistoryItemName, HistoryItemDescription, HistoryItemStatus, HistoryItemAssignee, HistoryFileItem, HistoryAnswerItem, HistoryDeadlineItem, HistoryItemAttribute, HistoryItemAuthor]);
  var createPredicateHistoryItem = _GTechIssue.createPredicateHistoryItem = function (field) {
    return function (item) {
      return item.field === field;
    };
  };
  var isHistoryFileItem = _GTechIssue.isHistoryFileItem = createPredicateHistoryItem('_file');
  var isHistoryItemStatus = _GTechIssue.isHistoryItemStatus = createPredicateHistoryItem('status');
  var isHistoryItemName = _GTechIssue.isHistoryItemName = createPredicateHistoryItem('name');
  var isHistoryItemDescription = _GTechIssue.isHistoryItemDescription = createPredicateHistoryItem('description');
  var isHistoryItemAssignee = _GTechIssue.isHistoryItemAssignee = createPredicateHistoryItem('__issueAssignee');
  var isHistoryAnswerItem = _GTechIssue.isHistoryAnswerItem = createPredicateHistoryItem('_issueAnswer');
  var isHistoryDeadlineItem = _GTechIssue.isHistoryDeadlineItem = createPredicateHistoryItem('deadline');
  var isHistoryItemAttribute = _GTechIssue.isHistoryItemAttribute = createPredicateHistoryItem('__issueAttribute');
  var isHistoryAuthorItem = _GTechIssue.isHistoryAuthorItem = createPredicateHistoryItem('author');
  var HistoryChanges = _GTechIssue.HistoryChanges = BaseHistoryChanges.io(HistoryItem);
  var fetchHistoryChanges = _GTechIssue.fetchHistoryChanges = ApiCallService.create({
    name: 'historyChanges',
    parentDomain: domain,
    result: HistoryChanges,
    getKey: ['issueId']
  });
  var changeStatus = _GTechIssue.changeStatus = ApiCallService.create({
    name: 'changeStatus',
    parentDomain: domain,
    result: IssuePopulated,
    getKey: ['issueId', 'issueVersion']
  });
})(GTechIssue || (GTechIssue = {}));